import React from 'react';
import { fontSize, Text } from '../../utils/style/texts';
import { useTranslation } from 'react-i18next';
import { Flex } from '../Container/Flex';

const ConfiguringAnimation = () => {
  const {t} = useTranslation();

  return (
    <Flex col align="center" style={{marginTop: 20}}>
      <img alt="configuring" style={{width: 165}} src={require('../../images/configuring.svg').default} />
      <Text style={{
        marginTop: 20,
        fontSize: fontSize.xl
      }}>{t('configuring')}...</Text>
    </Flex>
  );

};

export default ConfiguringAnimation;